import React, {ReactNode, memo, useMemo} from 'react';
import {buildTitleLayerClassName} from "@ui/leafletCustom/titleLayer/helpers/buildTitleLayerSelector";
import {buildStyles} from "@ui/leafletCustom/leafletContainer/sx";
import {MediaStyle} from "@baseTypes/base";
import Box from '@mui/material/Box';
import {ISxMap} from "@ui/leafletCustom/leafletContainer/types";

interface IProps {
    children: ReactNode,
    titleLayerKey: string,
    sx?: ISxMap,
    size?: {
        height?: MediaStyle<string | number>,
        width?: MediaStyle<string | number>,
    },
}

const LeafletContainerView = memo(({
                                  titleLayerKey,
                                  sx,
                                  size,
                                  children
                              }: IProps) => {

    const titleLayerSelector = buildTitleLayerClassName(titleLayerKey)

    const styles = useMemo(() => {
        return buildStyles({
            sx,
            size,
        })
    }, [sx, size])


    return (
        <Box
            className={titleLayerSelector}
            sx={styles}
        >
            {children}
        </Box>
    );
});

export default LeafletContainerView;